import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default () => {
  return (
    <SvgIcon>
      <svg version="1.1" x="0px" y="0px" viewBox="0 0 200 200">
        <path
          d="M64.8,41.4L35.7,56.3l62.5,32c1.5,0.7,3.2,0.7,4.7,0l26.8-13.7C129.6,74.7,64.8,41.4,64.8,41.4z M76,35.7l63.3,32.5
	c0.5,0.2,0.9,0.5,1.2,0.9l24.8-12.7l-62.5-32c-1.5-0.7-3.2-0.7-4.7,0L76,35.7L76,35.7z M169.5,65.7l-27.4,14v24.6
	c0,2.8-2.3,5.1-5.1,5.1c-2.8,0-5.1-2.3-5.1-5.1V85l-24.4,12.5c-0.6,0.3-1.2,0.6-1.9,0.8v76l63.8-32.7L169.5,65.7L169.5,65.7z
	M95.4,98.3c-0.6-0.2-1.3-0.5-1.9-0.8l-62-31.7v75.9l63.8,32.7V98.3L95.4,98.3z M179.7,57.3c0,0.1,0,0.1,0,0.2v87.1
	c0,0.2,0,0.5,0,0.7c-0.1,0.7-0.3,1.4-0.7,2c-0.4,0.6-0.9,1.2-1.5,1.6c-0.2,0.1-0.4,0.3-0.6,0.4l-69.3,35.5c-4.4,2.2-9.6,2.2-14,0
	l-69.3-35.5c-0.2-0.1-0.4-0.2-0.6-0.4c-0.6-0.4-1.1-0.9-1.5-1.6c-0.4-0.6-0.6-1.3-0.7-2c0-0.2,0-0.5,0-0.7V57.5c0-0.1,0-0.1,0-0.2
	v-1.8c0-0.2,0-0.5,0-0.7c0.1-0.7,0.3-1.4,0.7-2c0.4-0.6,0.9-1.2,1.5-1.6c0.2-0.1,0.4-0.3,0.6-0.4l69.3-35.5c4.4-2.2,9.6-2.2,14,0
	l69.3,35.5c0.2,0.1,0.4,0.2,0.6,0.4c0.6,0.4,1.1,0.9,1.5,1.6c0.4,0.6,0.6,1.3,0.7,2c0,0.2,0,0.5,0,0.7L179.7,57.3L179.7,57.3z"
        />
      </svg>
    </SvgIcon>
  );
};
